// src/viewport/constants.ts
var ADDON_ID = "storybook/viewport", PARAM_KEY = "viewport", PANEL_ID = `${ADDON_ID}/panel`, TOOL_ID = `${ADDON_ID}/tool`;

export {
  ADDON_ID,
  PARAM_KEY,
  PANEL_ID,
  TOOL_ID
};
